import component from './AppsumoCodePage.vue'
export default component
